import { useEffect, useMemo, useState } from 'react';
import countryList from 'react-select-country-list';
import { State } from 'country-state-city';
export function useGetStates(Countryvalue) {
    const countryOptions = useMemo(() => countryList().getData(), []);
    const [states, setStates] = useState([]);
    const getStates = async (Countryvalue) => {
        try {
          const result = await State.getStatesOfCountry(Countryvalue);
          let allStates = [];
          allStates = result?.map(({ isoCode, name }) => ({
            isoCode,
            name
          }));
          setStates(allStates);
        } catch (error) {
          setStates([]);
        }
      };
    useEffect(() => {
        getStates(Countryvalue);
    }, [Countryvalue]);

    return {states, countryOptions: countryOptions.filter(country => country.value === 'US')};
}
